module.exports = __webpack_public_path__ + "img/bannerRed.62aed202.jpg";